import { SVGProps } from "react";

const STIBing = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Bing" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#fff" /><path d="M145,73l73,26V356l103-59-50-24-32-79,162,57v83L218,439l-73-41Z" fill="#008373" /></svg>;

export { STIBing };